// extracted by mini-css-extract-plugin
module.exports = {"container":"_6c97079b1b--container--XLS8R","title":"_6c97079b1b--title--iSQLQ","link":"_6c97079b1b--link--xkVLc"};